/*
Copyright 2025 iodyne.  All rights reserved.
iodyne Proprietary/Confidental: INTERNAL USE ONLY
*/

import { defaultNS } from '@/i18n/settings';
import { createFileRoute, useLocation } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next';
import ProjectIconSrc from '@/components/icons/svg/project_icon.svg';
import IodyneCloudIcon from '@/components/icons/IodyneCloudIcon';
import { Button } from '@/components/ui/button';
import { useState } from 'react';
import { RedirectForAuthPopup } from '@/components/controllers/auth/ValidateAccessToken';

export const Route = createFileRoute('/project/$project_id/public')({
  component: RouteComponent,
  validateSearch: (search) => ({
    project_name: search.project_name as string ?? "",
    org_name: search.org_name as string ?? "",
    coverart_uri: search.coverart_uri as string ?? ""
  })
})

function RouteComponent() {
    const { t } = useTranslation(defaultNS);
    const { project_id } = Route.useParams();
    const { project_name, org_name, coverart_uri } = Route.useSearch();
    const { url } = useLocation({
        select: (location) => ({ url: location.href })
    });
    const [do_login, setDoLogin] = useState<boolean>(false);

    const cover_art_valid = coverart_uri.startsWith(process.env.IOD_CLOUD_PORTAL_USER_ASSETS_BASE_URI!);
    const redirect_uri = url.split("/public", 1)[0];

    return <div className="flex flex-col w-full h-screen justify-center">
        {(do_login || !project_name || !org_name) && <RedirectForAuthPopup 
                              title={t("auth.not_logged_in_title")}
                              message={t("auth.not_logged_in_msg")}
                              redirectURI={redirect_uri} />}
        {!do_login && <div className="flex flex-row justify-center items-center">
            <div className="flex flex-col justify-center rounded-md bg-card">
                <div className="flex flex-col items-center space-y-4 p-8">
                    {/* Project Details */}
                    <div>
                        {coverart_uri && cover_art_valid && <img
                            alt={project_name}
                            className="rounded-lg drop-shadow-[0_3px_3px_#222]"
                            src={coverart_uri}
                            width={200}
                            height={200} />}
                        {(!coverart_uri || !cover_art_valid ) && <ProjectIconSrc height={200} />}
                    </div>
                    <div className="text-2xl">
                        {project_name}
                    </div>
                    <div>
                        {t(
                            "label_unauthenticated_project_detail", 
                            { 
                                "project_name": project_name,
                                "org_name" : org_name
                            })}
                    </div>
                    {/* Actions */}
                    <div className="mt-5">
                        <Button
                            onClick={(e) => setDoLogin(true)}>
                            {t("label_view_details")}
                        </Button>
                    </div>
                </div>
                {/* Footer */}
                <div className="flex flex-row justify-end mt-5">
                    <IodyneCloudIcon height={50} />
                </div>
            </div>
        </div> }
    </div>
}
